import NewsletterForm from "@/components/global-components/NewsletterForm/NewsletterForm";
import { ColorOptions, IWPTitleParts } from "@/src/types";
import React from "react";
import S from "./Newsletter.styled";
import TitleParts from "@/components/global-components/TitleParts";
import { motion } from "framer-motion";
import { motionAnimation } from "@/styles/global";
import { isLight } from "@/src/helpers";

export interface NewsletterProps {
  blockId: string;
  backgroundColor: ColorOptions;
  backgroundType: "card" | "fill";
  titleParts: IWPTitleParts;
  title: string;
  smallTitle: string;
}

const Newsletter: React.FC<NewsletterProps> = ({
  blockId = "",
  backgroundColor,
  backgroundType,
  titleParts,
  title,
  smallTitle,
}) => {
  return (
    <S.Section
      id={blockId}
      $backgroundColor={backgroundColor}
      $backgroundType={backgroundType}
      as={motion.section}
      {...motionAnimation}
    >
      <S.Inner>
        <S.TitleWrapper>
          <S.Title>
            {titleParts ? (
              <TitleParts
                titleParts={titleParts}
                backgroundColor={backgroundColor}
              />
            ) : (
              title && title
            )}
          </S.Title>
          {smallTitle && (
            <S.SmallTitle
              $color={
                backgroundColor === "yellow"
                  ? "brown"
                  : isLight(backgroundColor)
                    ? "black"
                    : "creme"
              }
            >
              {smallTitle}
            </S.SmallTitle>
          )}
        </S.TitleWrapper>
        <NewsletterForm colorOptions={backgroundColor} />
      </S.Inner>
    </S.Section>
  );
};

export default Newsletter;
